import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <p className="copyright">© 2025 Sterling Rain Projects LTD. All rights reserved.</p>
          
        </div>
      </div>
    </footer>
  );
};

export default Footer;

 // <div className="social-links">
 //            <a href="https://instagram.com" className="social-link" target="_blank" rel="noopener noreferrer">Instagram</a>
 //            <a href="https://vimeo.com" className="social-link" target="_blank" rel="noopener noreferrer">Vimeo</a>
 //            <a href="https://linkedin.com" className="social-link" target="_blank" rel="noopener noreferrer">LinkedIn</a>
 //          </div>